/**
 * 静的HTMLを表示するコンポーネント
 */
export default {
    name: 'ShowStaticHtml',
    template: '#show_static_html_template',
    data () {
        return {
            // font-family定義
            font_families: {},
            // aタグのターゲット
            a_elements: {},
        };
    },
    props: {
        // 編集データ
        edit_data: {
            type: Object,
            default: () => ({}),
            required: true
        },
        // aタグにtarget属性をつけるかのフラグ
        target_blank: {
            type: Boolean,
            default: false,
        },
        // 直接展開するinnerHTML
        inner_html: {
            type: String,
            default: '',
        },
    },
    created: function () {
        // json文字列で描画されているfont-family定義を取得
        const data = document.querySelector('[data-roll="font_families"]');
        if (data) {
            this.font_families = JSON.parse(data.innerHTML);
        }
    },
    mounted: function () {
        if (!this.isEmptyInnerHtml) {
            this.$refs.show_static_html.innerHTML = this.inner_html;
        }
    },
    watch: {
        style: async function () {
            // プレビュー画面での呼び出しならaタグにtargetを指定
            if (this.target_blank) {
                await this.$nextTick();
                this.a_elements = this.$refs.show_static_html.getElementsByTagName('a');
                for (let i = 0; i < this.a_elements.length; i++){
                    this.a_elements[i].setAttribute('target', '_blank');
                };
            }
        }
    },
    computed: {
        // スロットが未使用か
        isEmptySlot: function () {
            return isSlotEmpty(this.$slots) && this.isEmptyInnerHtml;
        },
        isEmptyInnerHtml: function () {
            return this.inner_html === '';
        },
        // 全体デザイン(slotを使う場合のみ適用)
        wrapStyle: function () {
            return (this.isEmptySlot) ? {} : this.style;
        },
        // デザイン
        style: function () {

            if (!Object.keys(this.edit_data).length) {
                return;
            }

            // font-family定義から実値を取得
            let fontFamily = '';
            if (typeof this.font_families[this.edit_data.font_family] !== 'undefined') {
                fontFamily = this.font_families[this.edit_data.font_family];
            }

            return {
                'width': '100%',
                'display': 'flex',
                'flex-wrap': 'wrap',
                'flex-direction': 'column',
                'align-items': this.edit_data.wrap_align,
                'background': this.edit_data.background,
                'font-family': fontFamily,
                'font-size': this.edit_data.sync_data.main.font_size + 'px',
                'color': this.edit_data.font_color,
            };
        },
    }
};
